import { HomePage, ProfilePage } from './pages';

export const routes = {
  '/': {
    index: 0,
    text: 'Home',
    icon: 'home',
    showInMenuDropdown: false,
    component: HomePage
  },
  '/profile': {
    index: 99,
    text: 'Profile',
    icon: 'card',
    showInMenuDropdown: true,
    component: ProfilePage
  }
};

